import React from 'react';

import facebookIcon from 'assets/svg/social-icons/facebook.svg';
import instagramIcon from 'assets/svg/social-icons/instagram.svg';
import tiktokIcon from 'assets/svg/social-icons/tiktok.svg';
import youtubeIcon from 'assets/svg/social-icons/youtube.svg';

import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';

import styles from './styles.module.scss';

export class GlamstarSobre extends React.Component {
  socials = [
    {
      name: 'Insta Glambox',
      url: 'https://www.instagram.com/glamboxbrasil/',
      icon: instagramIcon,
    },
    {
      name: 'Tiktok Glambox',
      url: 'https://www.tiktok.com/@glamboxbrasil',
      icon: tiktokIcon,
    },
    {
      name: 'Youtube Glambox',
      url: 'https://www.youtube.com/user/glamboxbrasil',
      icon: youtubeIcon,
    },
    {
      name: 'Facebook Glambox',
      url: 'https://www.facebook.com/groups/370139723645396',
      icon: facebookIcon,
    },
    {
      name: 'Insta Glampartners',
      url: 'https://www.instagram.com/glampartner/',
      icon: instagramIcon,
    },
  ];

  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={styles.container}>
        {/* <header className={styles.concurseHeader}>
          <span className={styles.concurseTitle}>Seu status no concurso</span>
          <strong className={styles.concurseStatus}>Ativo</strong>
        </header> */}
        <main className={styles.hero}>
          <article className={styles.aboutArticle}>
            <h1>Sobre o concurso</h1>

            <div className={styles.banner}></div>

            <p className={styles.paragraph}>
              O <strong>Glamstar</strong> é o concurso que vai revelar a mais
              nova influenciadora do Brasil! Em sua terceira edição, a
              competição vem com novos challenges, madrinhas e um super evento
              na grande final em São Paulo! A ganhadora leva o prêmio de R$100
              MIL em contrato com a Glambox, enquanto a segunda e a terceira
              colocadas ganham R$50 MIL e R$20 MIL em contrato.
            </p>
            <p className={styles.paragraph}>
              Serão 12 challenges ao todo, cada um apresentado por uma de nossas
              madrinhas glamurosas: Camila Queiroz, Tata Estaniecki e Patrícia
              Ramos. Além de guiar nossas participantes, as madrinhas irão
              ajudar na decisão final. Já deu para perceber que vai ser
              incrível, né?!
            </p>

            <p className={styles.paragraph}>
              Acompanhe diariamente as redes sociais da Glambox e o portal das
              Glampartners, e fique atenta em relação aos prazos para envio dos
              challenges. Tudo estará explicadinho em cada etapa na página de
              Challenges.
            </p>
            {/* <span className={styles.toKnowMore}>
              Para ver os Termos e Condições do concurso,{' '}
              <button type="button" onClick={this.handleOpenTerms}>
                clique aqui
              </button>
              .
            </span> */}
          </article>
          <section className={styles.socialNetworkSection}>
            <h2>Acompanhe nossas redes sociais!</h2>

            <div className={styles.networks}>
              {this.socials.map(social => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.social}
                >
                  <img src={social.icon} alt={social.name} />
                  <span>{social.name}</span>
                </a>
              ))}
            </div>
          </section>
          <section className={styles.doubtSection}>
            <h2>Ficou com alguma dúvida?</h2>
            <p className={styles.paragraph}>
              Qualquer dúvida, entre em contato conosco através do e-mail{' '}
              <a href="mailto:glampartners@b4a.com.br">
                glampartners@b4a.com.br
              </a>
              .
            </p>
          </section>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
});

GlamstarSobre = connect(mapStateToProps, mapDispatchToProps)(GlamstarSobre);
